import React from 'react';
import Loading from '../../Loading';
import styles from './ConnectWallet.module.scss';

const Pending: React.FC = () => (
  <div className={styles.pending}>
    <Loading />
  </div>
);

export default Pending;
